import { render, staticRenderFns } from "./NftHistory.vue?vue&type=template&id=5f09abae"
import script from "./NftHistory.vue?vue&type=script&lang=js"
export * from "./NftHistory.vue?vue&type=script&lang=js"
import style0 from "./NftHistory.vue?vue&type=style&index=0&id=5f09abae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports